import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import Image from './Image';
import ImageFullView from './ImageFullview';
export const ImageFullViewWrapper = (props)=>{
    const isNewFullview = useFlag('seo_new_fullview');
    if (isNewFullview) {
        return /*#__PURE__*/ React.createElement(ImageFullView, props);
    }
    return /*#__PURE__*/ React.createElement(Image, props);
};
ImageFullViewWrapper.displayName = 'ImageFullViewWrapper';
export default ImageFullViewWrapper;
